<div class="right-navbar">
    <div class="top-container">
        <p class="heading">Your Cart:</p>
        <mat-icon (click)="closeNavbar()" class="close-icon">close</mat-icon>
    </div>
    <div class="middle-container">
        @for (item of products; track $index) {
        <div class="item-content-block">
            <div class="item-content">
                <div class="left-content">
                    <div class="image-container" (click)="onClickProduct(item.product.id)">
                        <img
                            class="image"
                            *ngIf="item.product.images; else placeholder"
                            [src]="item.product.images.imagesUrl[0]"
                            alt="Item Image"
                        />
                        <ng-template #placeholder>
                            <div class="image-placeholder"></div>
                        </ng-template>
                    </div>
                </div>
                <div class="right-content">
                    <p
                        class="product-name"
                        [matTooltipShowDelay]="800"
                        [matTooltipHideDelay]="500"
                        [matTooltip]="item.product.name"
                        matTooltipPosition="above"
                    >
                        {{ item.product.name }}
                    </p>
                    <div class="price-content">
                        <span *ngIf="item.product.discountedPrice; else noDiscount">
                            <span class="price">{{ "currency.rs" | translate }}{{ item.product.discountedPrice }}</span>
                            &nbsp;
                            <s class="cut-price">{{ "currency.rs" | translate }}{{ item.product.price }}</s>
                        </span>
                        &nbsp;
                        <span class="discount-percentage" *ngIf="item.product.discountedPrice"
                            >{{ item.product.discountPercentage }}% {{ "productOffer.off" | translate }}</span
                        >
                        <ng-template #noDiscount>
                            <span class="price">₹ {{ item.product.price }}</span>
                        </ng-template>
                    </div>

                    <div class="quantity-delete">
                        <div class="quantity-container">
                            <span
                                ><button
                                    class="decrement"
                                    (click)="onClick(-1, item.product.id, item.cartUUID!)"
                                    [disabled]="getProductQtyInCart(item.product.id, item.cartUUID!) <= minQuantity"
                                >
                                    -
                                </button></span
                            >
                            <input
                                type="number"
                                class="quantity"
                                [value]="getProductQtyInCart(item.product.id, item.cartUUID!)"
                                (input)="onInputChange($event, item.product.id, item.cartUUID!)"
                                (blur)="onBlur($event, item.product.id, item.cartUUID!)"
                            />
                            <span
                                ><button
                                    class="increment"
                                    (click)="onClick(1, item.product.id, item.cartUUID!)"
                                    [disabled]="getProductQtyInCart(item.product.id, item.cartUUID!) >= maxQuantity"
                                >
                                    +
                                </button></span
                            >
                        </div>
                        <span class="delete" (click)="onDeleteCartItem(item)">{{
                            "cart.label.remove" | translate
                        }}</span>
                    </div>
                </div>
            </div>

            <div class="block-item-info-container" *ngIf="item.product.category.includes(categories.BuyBlocks)">
                <div class="node-hole-plane-config">
                    <div *ngIf="getFacesByType(item, 'Plane').length > 0" class="plane-config">
                        <span class="block-face-label">{{ "cart.shapeFacetype.plane" | translate }}: </span>
                        <span class="block-face-value">{{ getFacesByType(item, "Plane") }}</span>
                    </div>

                    <div *ngIf="getFacesByType(item, 'Hole').length > 0" class="hole-config">
                        <span class="block-face-label">{{ "cart.shapeFacetype.hole" | translate }}: </span>
                        <span class="block-face-value">{{ getFacesByType(item, "Hole") }}</span>
                    </div>

                    <div *ngIf="getFacesByType(item, 'Node').length > 0" class="node-config">
                        <span class="block-face-label">{{ "cart.shapeFacetype.node" | translate }}: </span>
                        <span class="block-face-value">{{ getFacesByType(item, "Node") }}</span>
                    </div>
                </div>

                <div class="color-config">
                    <div class="color-title-section">
                        <p class="color-title">Color configuration</p>
                    </div>

                    <div class="color-info">
                        <div *ngFor="let color of getFaceColors(item.singleBlockInfo?.color)">
                            <div class="color-item">
                                <div
                                    class="color-box"
                                    [ngStyle]="{ 'background-color': getColorValue(color.value) }"
                                ></div>
                                <div class="color-name">
                                    <span class="block-face-label">{{ color.key }} </span>
                                    <span class="block-face-value">
                                        {{ color.value }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="separator"></div>
        }
    </div>

    <div class="bottom-section">
        <p class="price-details-heading">PRICE DETAILS</p>
        <br />
        <p class="mrp-value">
            <span>Total MRP</span> <span>₹ {{ totalMRP }}</span>
        </p>
        <p class="discount-mrp">
            <span>Discount on MRP</span> <span>- ₹ {{ totalDiscount }}</span>
        </p>
        <div class="separator"></div>
        <p class="totl-amount">
            <span>Total Amount</span> <span>₹ {{ totalAmount }}</span>
        </p>
    </div>

    <div class="button-container">
        <app-button
            variant="white"
            [disabled]="!isCheckoutEnabled"
            buttonClass="explore-btn shadow-btn hover-bounce"
            (onClick)="onCheckout()"
        >
            {{ "cart.button.proceedToBuy" | translate }}
        </app-button>
    </div>

    <div *ngIf="!isCheckoutEnabled" class="min-purchase-message">
        {{ "cart.minOrderAmount" | translate }}
    </div>
</div>
